import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-login",
  "use": "icon-login-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"icon-login\"><path d=\"M10.6 13.057a6.4 6.4 0 10-6.4-6.4 6.407 6.407 0 006.4 6.4zm0-11.2a4.8 4.8 0 110 9.6 4.8 4.8 0 010-9.6zm4.8 12H5.8a5.606 5.606 0 00-5.6 5.6.8.8 0 00.8.8h19.2a.8.8 0 00.8-.8 5.606 5.606 0 00-5.6-5.6zm-13.52 4.8a4.005 4.005 0 013.92-3.2h9.6a4.007 4.007 0 013.919 3.2H1.879z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol